import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { useI18n } from "../i18n";

const FAQ = () => {
  const { t, lang } = useI18n();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section-light relative py-24 md:py-32 border-y border-[#e7d5de]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-12 text-center"
        >
          <div className="text-xs tracking-[0.25em] uppercase text-[#A60056] font-semibold mb-4">
            {lang === "pt" ? "Dúvidas frequentes" : "Frequently asked"}
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-[#1a0b12]">{t.faq.title}</h2>
        </motion.div>

        <Accordion type="single" collapsible className="w-full space-y-3">
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={`${lang}-${item.q}`}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-[#eadbe3] rounded-2xl px-6 bg-white data-[state=open]:border-[#A60056]/40 data-[state=open]:bg-[#A60056]/[0.05] transition-colors"
            >
              <AccordionTrigger className="text-left text-[#1a0b12] hover:no-underline py-5 text-base md:text-lg font-medium">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5c4a54] leading-relaxed text-[15px] pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
